import LocomotiveScroll from "locomotive-scroll";
const locomotiveInit = () => {
  const scrollContainer = document.querySelector("[data-scroll-container]");

  const scroll = new LocomotiveScroll({
    el: scrollContainer,
    smooth: true,
    direction: "vertical",
    offset: "30%",
    class: "visible",
    smartphone: {
      smooth: true,
    },
    tablet: {
      smooth: true,
    },
  });

  setTimeout(() => {
    scroll.update();
  }, 1000);

  const buttons = document.querySelectorAll('.looking__block .btn, .btn--scroll');

  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
  
        const targetHref = this.getAttribute('href');
  
        if (targetHref.includes('#')) {
          const [page, hash] = targetHref.split('#');
  
          if (!page || window.location.pathname.includes(page)) {
            const target = document.querySelector(`#${hash}`);
            if (target) {
              scroll.scrollTo(target);
            } 
          }
  
          if (page && !window.location.pathname.includes(page)) {
            window.location.href = targetHref;
          }
        }
      });
    });
  }

  let hasLeftBlocks = {};

  scroll.on('scroll', (instance) => {
      const blockLines = document.querySelectorAll('.block--line'); 
  
      blockLines.forEach((blockLine, index) => {
          const blockBottom = blockLine.getBoundingClientRect().bottom;
          const viewportHeight = window.innerHeight;
          const vh = viewportHeight * 0.8; 
  
          if (blockBottom < vh && !hasLeftBlocks[index]) {
              hasLeftBlocks[index] = true; 
              blockLine.classList.add('active'); 
          }
      });
  });
  
  return scroll;
};
export default locomotiveInit;
